import ContractPeriod from '@/models/HumanResource/HrContractPeriod'

export default () => {
    try {
        let response = ContractPeriod.params({ get_all_result: true }).get()
        return response
    } catch (error) {
        return error.response.data
    }
}
